// Hook do pobierania listy produktów klienta (wyszukiwarka) – GET /sales-crm/clients/:clientId/products?search_keyword=...

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IProductListItem } from 'api/types';

/** Odpowiedź API listy produktów klienta */
export interface IClientProductsResponse {
  items: IProductListItem[];
  total_count: number;
  total_pages?: number;
}

export interface IClientProductsListParams {
  search_keyword?: string;
  page?: number;
  limit?: number;
  category_id?: number;
  filter_attributes?: string;
  sort_method?: string;
}

const getClientProducts = (
  clientId: number,
  params: IClientProductsListParams
): Promise<IClientProductsResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/products`, {
    params: {
      search_keyword: params.search_keyword || undefined,
      limit: params.limit ?? 10,
      page: params.page ?? 1,
      category_id: params.category_id || undefined,
      filter_attributes: params.filter_attributes || undefined,
      sort_method: params.sort_method || undefined
    }
  });

/** Hook do wyszukiwarki w HeaderTopBar – wymaga niepustej frazy */
export const useGetClientProducts = (
  clientId: number | null,
  searchKeyword: string,
  options?: UseQueryOptions<IClientProductsResponse, IError>
) =>
  useQuery<IClientProductsResponse, IError>(
    ['sales-crm', 'clients', clientId, 'products', searchKeyword],
    () => getClientProducts(clientId!, { search_keyword: searchKeyword }),
    {
      ...options,
      enabled:
        (options?.enabled !== false) &&
        clientId != null &&
        clientId > 0 &&
        searchKeyword.trim().length > 0
    }
  );

/** Hook do listingu produktów klienta (strona TraderPanelProductsList) – obsługuje pustą frazę i paginację */
export const useGetClientProductsList = (
  clientId: number | null,
  params: IClientProductsListParams,
  options?: UseQueryOptions<IClientProductsResponse, IError>
) =>
  useQuery<IClientProductsResponse, IError>(
    ['sales-crm', 'clients', clientId, 'products-list', params],
    () => getClientProducts(clientId!, params),
    {
      ...options,
      enabled: (options?.enabled !== false) && clientId != null && clientId > 0
    }
  );
